"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as t } from "react";
import e from "../components/Icon/SvgIcon.js";
const r = (l) => /* @__PURE__ */ o(
  e,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m6.005 5.784 14.734.002c.645 0 .887.26.7.968l-1.572 6.688a.54.54 0 0 1-.54.464H7.93l.308 1.392a.78.78 0 0 0 .789.619h9.627c.28 0 .52.243.52.542a.54.54 0 0 1-.538.541H8.932c-.793-.03-1.658-.72-1.772-1.624l-.462-2.011-2.31-9.282H2.54A.54.54 0 0 1 2.539 3h2.31c.285 0 .47.149.54.386zM11 19a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m8 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
        clipRule: "evenodd"
      }
    )
  }
), c = t(r);
export {
  c as CartSolid,
  c as default
};
